exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.break-protect[data-v-49438786] {\n    page-break-inside: avoid;\n}\n.body[data-v-49438786] {\n    margin: 25mm;\n}\n@page {\n    margin-top: 1in;\n    margin-bottom: 1in;\n}\n", ""]);

// exports
